import produce from 'immer'
import { REFRESH_DATA } from '../actions/actionTypes'
import { actionTypes } from '../actions/restaurantActions'
import { StorageKeys } from '../constants'
import { setObjectData } from '../utils/localStorageHelper'
import { getPaymentMethodsSupport } from '../utils/restaurant'
// const initialState = getObjectData(StorageKeys.restaurantData) || null
const initialState = null

const RestaurantReducer = (state = initialState, action) =>
    produce(state, draft => {
        switch (action.type) {
            case actionTypes.SET_RESTAURANT_INFO: {
                const restaurant = action.payload
                restaurant.paymentMethodsSupport = getPaymentMethodsSupport(restaurant)
                setObjectData(StorageKeys.restaurantData, restaurant)
                return action.payload
            }
            case actionTypes.UPDATE_RESTAURANT_INFO: {
                const {
                    customerNumber,
                    tableOrdersId,
                    verificationCode,
                } = action.payload
                draft.customerNumber = customerNumber
                draft.tableOrdersId = tableOrdersId
                draft.verificationCode = verificationCode
                setObjectData(StorageKeys.restaurantData, draft)
                break
            }
            case actionTypes.CHECK_TABLE_STATUS_SUCCESS: {
                const {
                    state: s,
                    // tableOrdersId
                } = action.payload
                // draft.tableOrdersId = tableOrdersId
                draft.state = s
                setObjectData(StorageKeys.restaurantData, draft)
                break
            }
            case actionTypes.REQUEST_TABLE_SUCCESS: {
                const { tableOrdersId, state } = action.payload
                draft.state = state
                draft.tableOrdersId = tableOrdersId
                setObjectData(StorageKeys.restaurantData, draft)
                break
            }
            case REFRESH_DATA: {
                setObjectData(StorageKeys.restaurantData, null)
                return null
            }
            default:
                return state
        }
    })

export default RestaurantReducer
